import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=3bbaa95a&"
import script from "./ReportsPage.vue?vue&type=script&lang=js&"
export * from "./ReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bbaa95a')) {
      api.createRecord('3bbaa95a', component.options)
    } else {
      api.reload('3bbaa95a', component.options)
    }
    module.hot.accept("./ReportsPage.vue?vue&type=template&id=3bbaa95a&", function () {
      api.rerender('3bbaa95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/ReportsPage.vue"
export default component.exports